<div class="exception-body notfound">
    <div class="exception-panel">
        <div class="exception-image">
            <img src="assets/layout/images/exception/icon-404.png">
        </div>

        <div class="exception-detail">
            <h1>{{currentUser.initials | uppercase }}</h1>
            <p>Solicite la asignación al administrador del sistema y vuelva a ingresar</p>
            <p-button label="IR AL INICIO" [routerLink]="['/']"></p-button>
            <button pButton type="button" label="SALIR" class="p-button-danger" (click)="salir()"></button>
        </div>
    </div>
</div>
